import { theme } from "antd";
const { defaultAlgorithm, darkAlgorithm, compactAlgorithm } = theme;

export const light = [defaultAlgorithm];
export const dark = [darkAlgorithm];
export const compact = [defaultAlgorithm, compactAlgorithm];
